class ReportModel extends App.Models.BaseModel {
    modelUrl = 'Report';

    fetchWithCriteria = (obj) => {
        return Monet.Model.fetchWithCriteria({
            options: obj,
            model: this
        });
    }
}

App.Models.Report = ReportModel;
